import {productConfig} from '@/lib/productConfig';
import { Link } from 'react-router-dom';
import { Users, Store, ArrowRight } from 'lucide-react';
import useSeo from '@/hooks/useSeo';
import { appDestination } from '@/lib/appLinks';

export default function LoginChoice() {
  useSeo({title:'Log in — Orrbbit',description:'Sign in to Orrbbit and connect with people nearby.',path:'/login'});
  const personal=appDestination(process.env.REACT_APP_APP_URL,'/login?type=personal',window.location.origin);
  return <section className="container-x section-space" data-testid="login-choice-page">
    <h1 className="text-center font-heading text-4xl font-bold text-navy">Log in to Orrbbit</h1>
    <p className="mt-4 text-center text-bodygrey">Sign in in the Orrbbit app. Your account and privacy controls stay together.</p>
    <div className="mx-auto mt-10 grid max-w-4xl gap-6 md:grid-cols-1">
      <article className="flex flex-col rounded-3xl border border-teal/20 bg-white p-8 shadow-card">
        <Users size={40} className="text-teal"/><h2 className="mt-6 font-heading text-2xl font-bold text-navy">Sign in</h2>
        <p className="mb-8 mt-3 flex-1 text-bodygrey">Real people. Real moments. Right nearby.</p>
        <Link data-testid="personal-login-choice" to="/download" className="inline-flex min-h-[48px] items-center justify-center gap-3 rounded-full bg-teal px-6 py-3 font-semibold text-white">Open or get the People app <ArrowRight size={18}/></Link>
      </article>
      {productConfig.businessEnabled&&<article className="flex flex-col rounded-3xl border border-cobalt/20 bg-white p-8 shadow-card">
        <Store size={40} className="text-cobalt"/><h2 className="mt-6 font-heading text-2xl font-bold text-navy">Business login</h2>
        <p className="mb-8 mt-3 flex-1 text-bodygrey">Build your local presence and connect with your community.</p>
        <Link data-testid="business-login-choice" to="/business/login" className="inline-flex min-h-[48px] items-center justify-center gap-3 rounded-full bg-cobalt px-6 py-3 font-semibold text-white">Business login <ArrowRight size={18}/></Link>
      </article>}
    </div>
  </section>;
}
